import { Button, Group } from '@mantine/core'
import { notifications } from '@mantine/notifications'

import { describeError } from '../api/client'

export function notifyError(error: unknown): void {
  notifications.show({ color: 'red', message: describeError(error) })
}

export function notifySaved(message: string): void {
  notifications.show({ color: 'teal', message })
}

/** 8 s to undo a delete (redesign.md §4, identity.md §5): long enough to act on, not so long it lingers. */
const UNDO_TIMEOUT_MS = 8000

/**
 * The snackbar with one Undo action: 8 s on screen, then it closes itself. The id is generated up front so the Undo
 * button can close its own toast early.
 */
export function notifyUndo(message: string, onUndo: () => void): void {
  const id = crypto.randomUUID()
  notifications.show({
    id,
    autoClose: UNDO_TIMEOUT_MS,
    message: (
      <Group justify="space-between" wrap="nowrap" gap="md">
        <span>{message}</span>
        <Button
          variant="subtle"
          size="compact-sm"
          c="var(--md-sys-color-inverse-primary)"
          onClick={() => {
            onUndo()
            notifications.hide(id)
          }}
        >
          Undo
        </Button>
      </Group>
    ),
  })
}
